import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  UncontrolledTooltip
} from "reactstrap";
import { Link } from "react-router-dom";
import TableContainer from "../../../../components/Common/TableContainer";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { useFormik } from "formik";
import * as Yup from "yup";
import getAccessRights from "components/Common/getAccessRights";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from 'sweetalert2';
import CustomSelect from "components/Common/custom-select";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchActiveEmployees, fetchempprecloseLoannumber, getprecloseloancalculate, saveEmployeepreloanclosedetails } from "store/actions";
import Loader from "common/pageLoader";
import CustomDatePicker from "common/CustomDatePicker";


const PayrollLoanPreClose = () => {
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const [data, setData] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);

  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const accessRight = getAccessRights(location.pathname, history);
  }, [location]);

  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedLoan, setSelectedLoan] = useState(null);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      loanNumber: "",
      outstandingPrincipal: "",
      type: "Partial",
      preCloseAmount: "",
      balanceAmount: "0",
      installments: "",
      installmentAmount: "0",
      totalAmount: "0",
      remarks: "",
      preCloseDate: "",
      employee: "",
    },
    validationSchema: Yup.object().shape({
      employee: Yup.string().nullable().required("Employee Code is required"),
      loanNumber: Yup.string().required("Loan Number is required"),
      type: Yup.string().required("Type is required"),
      preCloseAmount: Yup.number().required("Pre Close Amount is required"),
      balanceAmount: Yup.number(),
      installments: Yup.number().required("Installment is required"),
      installmentAmount: Yup.number(),
      totalAmount: Yup.number(),
      remarks: Yup.string().required("Remarks is required"),
      preCloseDate: Yup.date().required("Pre Close Date is required"),
      outstandingPrincipal: Yup.number().required("OutstandingPrincipal is required"),
    }),
    onSubmit: (values) => {
      const formData = new FormData();
      // console.log("Form Data", values);
      const selecteddata = data.map(row => ({
        pay_dtl_id: 0,
        installment_period: row.installment_period,
        payable_date: row.payable_date ? formatYearMonth(row.payable_date) : null,
        installment_amount: row.installment_amount,
        current_balance: row.current_balance,
        loan_interest: row.interest_amount,
        principal_amount: row.principal_amount,
      }));

      let result = { sch: selecteddata };

      formData.append("loan_id", selectedLoan.value);
      formData.append("emp_id", selectedEmployee.value);
      formData.append("loan_type_id", 0);
      formData.append("outstanding_amount", formik.values.outstandingPrincipal);
      formData.append("loan_close_type", formik.values.type === "Partial" ? 1 : 2);
      formData.append("pre_close_amount", formik.values.preCloseAmount);
      formData.append("loan_balance", formik.values.balanceAmount);
      formData.append("no_of_installment", formik.values.installments);
      formData.append("installment_amunt", formik.values.installmentAmount);
      formData.append("total_amount", formik.values.totalAmount);
      formData.append("remarks", formik.values.remarks);
      formData.append("pre_close_date", formik.values.preCloseDate);
      formData.append("unit_id", authDetails?.unit_id);
      formData.append("create_by", authDetails?.user_id);
      formData.append("lst_employee_loanclose", JSON.stringify(result));
      dispatch(saveEmployeepreloanclosedetails(formData));
      handleReset();
    },
  });

  const formatYearMonth = (date) => {
    if (!date) return null;
    const [day, month, year] = date.split("/");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  };

  const {
    employees,
    employeeloannumber,
    employeepreclose,
    loading,
    success,
    error,
    saveSuccess,
  } = useSelector((state) => ({
    employees: state.EmployeeDetailsReducer?.employeesActiveList ?? [],
    employeeloannumber: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.employeeloannumber ?? [],
    employeepreclose: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.employeepreclose ?? [],
    loading: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.loading,
    error: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.error,
    success: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.success,
    saveSuccess: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.saveSuccess,
  }));

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchActiveEmployees(unitId));
  }, [dispatch]);

  const findEmpgetloannumber = (empdata) => {
    if (empdata) {
      const formData = new FormData();
      formData.append("emp_id", empdata.value);
      formData.append("unit_id", authDetails?.unit_id);
      dispatch(fetchempprecloseLoannumber(formData));
    }
  }

  const loanOptions = Array.isArray(employeeloannumber) ? employeeloannumber.map((loan) => ({
    value: loan.loan_id,
    label: loan.loan_no,
    outstanding_amount: loan.outstanding_amount
  })) : [];

  const calculatepreclosevalue = (value) => {
    const preCloseAmount = Number(value.preCloseAmount) || 0;
    const outstandingPrincipal = Number(value.outstandingPrincipal) || 0;
    const installments = Number(formik.values.installments) || 0;

    const balance = preCloseAmount < outstandingPrincipal ? outstandingPrincipal - preCloseAmount : 0;
    const installmentAmount = installments > 0 ? balance / installments : 0;
    formik.setFieldValue("balanceAmount", balance);
    formik.setFieldValue("installments", installments);
    formik.setFieldValue("installmentAmount", installmentAmount);
    formik.setFieldValue("totalAmount", balance);
  }

  const resetFormData = () => {
    // formik.resetForm();
    dispatch({ type: "RESET_SAVE_STATUS" });
    setData([]);
    setSelectedEmployee(null);
    setSelectedLoan(null);
    formik.resetForm({
      values: {
        employee: "",
        loanNumber: "",
        outstandingPrincipal: "0",
        preCloseAmount: "0",
        balanceAmount: "0",
        installments: "",
        installmentAmount: "0",
        totalAmount: "0",
        remarks: "",
        preCloseDate: "",
      },
    });
  };

  const handleCalculate = async () => {
    const errors = await formik.validateForm();

    formik.setTouched({
      employee: true,
      loanNumber: true,
      type: true,
      preCloseAmount: true,
      installments: true,
      remarks: true,
      preCloseDate: true,
      outstandingPrincipal: true,
    });

    if (Object.keys(errors).length > 0) {
      return;
    }

    if (!selectedEmployee || !selectedLoan) {
      Swal.fire("Error", "Please fill all mandatory fields", "error");
      return;
    }
    const formData = new FormData();
    formData.append("loan_id", selectedLoan.value);
    formData.append("emp_id", selectedEmployee.value);
    formData.append("loan_type_id", 0);
    formData.append("outstanding_amount", formik.values.outstandingPrincipal);
    formData.append("loan_close_type", formik.values.type === "Partial" ? 1 : 2);
    formData.append("pre_close_amount", formik.values.preCloseAmount);
    formData.append("loan_balance", formik.values.balanceAmount);
    formData.append("no_of_installment", formik.values.installments);
    formData.append("installment_amunt", formik.values.installmentAmount);
    formData.append("total_amount", formik.values.totalAmount);
    formData.append("remarks", formik.values.remarks);
    formData.append("pre_close_date", formik.values.preCloseDate);
    formData.append("unit_id", authDetails?.unit_id);
    dispatch(getprecloseloancalculate(formData));
  }

  useEffect(() => {
    if (employeepreclose?.emp_loanschdet?.length > 0) {
      const generatedData = employeepreclose.emp_loanschdet.map((emp, index) => ({
        sno: index + 1,
        current_balance: emp.current_balance,
        installment_amount: emp.installment_amount,
        installment_period: emp.installment_period,
        interest_amount: emp.loan_interest,
        payable_date: emp.payable_date,
        principal_amount: emp.principal_amount
      })) || [];

      setData(generatedData);
    } else {
      setData([]);
    }
  }, [employeepreclose]);

  const columns = [
    {
      Header: "DATE",
      accessor: "payable_date",
      Footer: () => (
        <div
          style={{
            fontWeight: "700",
            color: "#0c0c0c",
            backgroundColor: "#f2f7f5", // green
            padding: "6px",
            textAlign: "center",
            width: "100%"
          }}
        >
          TOTAL
        </div>
      )
    },
    { Header: "PRINCIPAL", accessor: "principal_amount" },
    {
      Header: "MONTHLY_DEDUCTION",
      accessor: "installment_amount",
      Footer: info => {
        const total = info.rows.reduce(
          (sum, row) => sum + Number(row.values.installment_amount || 0),
          0
        );
        return (
          <div
            style={{
              fontWeight: "700",
              color: "#0c0c0c",
              backgroundColor: "#f2f7f5", // green
              padding: "6px",
              textAlign: "center",
              width: "100%"
            }}
          >
            ₹ {total.toLocaleString()}
          </div>
        );
      }
    },
    { Header: "INTEREST", accessor: "interest_amount" },
    { Header: "PERIOD", accessor: "installment_period" },
    { Header: "BALANCE", accessor: "current_balance" },
  ];

  useEffect(() => {
    if (saveSuccess) {
      dispatch({ type: "RESET_SAVE_STATUS" });
      resetFormData();
    }
  }, [saveSuccess, dispatch]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Breadcrumbs */}
          <Breadcrumbs title="Payroll / Employee Loan" breadcrumbItem="Loan Pre Close" />

          {/* Input Section */}
          <Card>
            <CardBody>
              <Form onSubmit={formik.handleSubmit}>
                <Row className="mb-3 g-3 align-items-center">
                  {/* Employee Code */}
                  <Col md={3}>
                    <FormGroup>
                      <Label>Emp Code <span className="text-danger"> *</span></Label>
                      <CustomSelect
                        id="employee"
                        name="employee"
                        options={employees}
                        value={selectedEmployee}
                        onChange={(selectedOption) => {
                          setSelectedEmployee(selectedOption);
                          if (selectedOption) {
                            formik.setFieldValue("employee", selectedOption.value);
                            findEmpgetloannumber(selectedOption);
                          }
                        }}
                        onBlur={() => formik.setFieldTouched("employee", true)}
                        className="react-select-container"
                        classNamePrefix="react-select"
                        isClearable={true}
                      />
                      {formik.touched.employee && formik.errors.employee && (
                        <div className="text-danger">{formik.errors.employee}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Loan Number */}
                  <Col md={3}>
                    <FormGroup>
                      <Label>Loan Number <span className="text-danger"> *</span></Label>
                      <CustomSelect
                        options={loanOptions}
                        value={loanOptions?.find(opt => opt.value === formik.values.loanNumber)}
                        onChange={(option) => {
                          setSelectedLoan(option);
                          formik.setFieldValue("loanNumber", option.value);
                          formik.setFieldValue("outstandingPrincipal", option.outstanding_amount);
                        }}
                      />
                      {formik.touched.loanNumber && formik.errors.loanNumber && (
                        <div className="text-danger">{formik.errors.loanNumber}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Outstanding Principal (Auto-filled) */}
                  <Col md={3}>
                    <FormGroup>
                      <Label>Outstanding Principal <span className="text-danger"> *</span></Label>
                      <Input type="number" name="outstandingPrincipal" value={formik.values.outstandingPrincipal} disabled />
                      {formik.touched.outstandingPrincipal && formik.errors.outstandingPrincipal && (
                        <div className="text-danger">{formik.errors.outstandingPrincipal}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Type Selection (Checkbox)  */}
                  <Col md={3}>
                    <FormGroup>
                      <Label>Type</Label>
                      <div className="d-flex">
                        <Label className="me-3">
                          <Input
                            type="radio"
                            name="type"
                            value="Partial"
                            onChange={formik.handleChange}
                            checked={formik.values.type === "Partial"} // Ensuring default selection
                            className="me-1"
                          />
                          Partial
                        </Label>
                        <Label className="me-3">
                          <Input type="radio" name="type" value="Full" onChange={formik.handleChange} checked={formik.values.type === "Full"} className="me-1" />
                          Full Settlement
                        </Label>
                      </div>
                    </FormGroup>
                  </Col>

                  {/* Auto-Filled Fields (Based on Type Selection) */}
                  <Col md={3}>
                    <FormGroup>
                      <Label>Pre Close Amount <span className="text-danger"> *</span></Label>
                      <Input
                        type="text"
                        name="preCloseAmount"
                        value={formik.values.preCloseAmount}
                        onChange={(e) => {
                          const val = e.target.value.replace(/[^0-9]/g, "");
                          formik.setFieldValue("preCloseAmount", val);
                          calculatepreclosevalue({ ...formik.values, preCloseAmount: val });
                        }}
                        onBlur={formik.handleBlur}
                        invalid={formik.touched.preCloseAmount && Boolean(formik.errors.preCloseAmount)}
                      />
                      {formik.touched.preCloseAmount && formik.errors.preCloseAmount && (
                        <div className="text-danger">{formik.errors.preCloseAmount}</div>
                      )}
                    </FormGroup>
                  </Col>

                  <Col md={3}>
                    <FormGroup>
                      <Label>Balance Amount</Label>
                      <Input type="number" name="balanceAmount" value={formik.values.balanceAmount} disabled />
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup>
                      <Label>No. of Installments <span className="text-danger"> *</span></Label>
                      <Input
                        type="text"
                        name="installments"
                        value={formik.values.installments}
                        onChange={(e) => {
                          const val = e.target.value.replace(/[^0-9]/g, "");
                          formik.setFieldValue("installments", val);
                        }}
                        onBlur={(e) => {
                          const val = Number(e.target.value) || 0;
                          formik.setFieldValue("installments", val);
                          calculatepreclosevalue({ ...formik.values, installments: val });
                          formik.handleBlur(e); // keep Formik touched state
                        }}
                        invalid={formik.touched.installments && Boolean(formik.errors.installments)}
                      />
                      {formik.touched.installments && formik.errors.installments && (
                        <div className="text-danger">{formik.errors.installments}</div>
                      )}
                    </FormGroup>
                  </Col>

                  <Col md={3}>
                    <FormGroup>
                      <Label>Installment Amount</Label>
                      <Input type="number" name="installmentAmount" value={formik.values.installmentAmount} disabled />
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup>
                      <Label>Total Amount</Label>
                      <Input type="number" name="totalAmount" value={formik.values.totalAmount} disabled />
                    </FormGroup>
                  </Col>

                  {/* Remarks */}
                  <Col md={3}>
                    <FormGroup>
                      <Label>Remarks <span className="text-danger"> *</span></Label>
                      <Input type="text" name="remarks" value={formik.values.remarks} onChange={formik.handleChange} />
                      {formik.touched.remarks && formik.errors.remarks && (
                        <div className="text-danger">{formik.errors.remarks}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Pre Close Date */}
                  <Col md={3}>
                    <FormGroup>
                      <Label>Pre Close Date <span className="text-danger"> *</span></Label>
                      <CustomDatePicker
                        value={formik.values.preCloseDate}
                        onChange={(date) =>
                          formik.setFieldValue("preCloseDate", date)
                        }
                        onBlur={() =>
                          formik.setFieldTouched("preCloseDate", true)
                        }
                      />
                      {formik.touched.preCloseDate &&
                        formik.errors.preCloseDate && (
                          <div className="text-danger">
                            {formik.errors.preCloseDate}
                          </div>
                        )}
                    </FormGroup>
                  </Col>

                  <Col className="d-flex align-items-center justify-content-end mt-4">
                    <Button type="button" className="btn button-save me-2" onClick={handleCalculate}>
                      <i className="fas fa-calculator me-1" />  Calculate
                    </Button>
                    <Button type="submit" className="btn button-save me-2"><i className="fas fa-save me-1" /> Save</Button>
                    <Button type="reset" className="btn button-cancel"
                      onClick={() => {
                        Swal.fire({
                          title: "Are you sure?", text: "Unsaved clear will be lost!", icon: "warning",
                          showCancelButton: true, confirmButtonText: "Yes, Clear", cancelButtonText: "No", confirmButtonColor: "#3085d6", cancelButtonColor: "#d33"
                        }).then((result) => {
                          if (result.isConfirmed) {
                            // formik.resetForm();
                            resetFormData();
                          }
                        });
                      }}
                    >
                      <i className="fas fa-sync me-1" /> Cancel
                    </Button>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>

          {/* Table Section */}
          <Card>
            <CardBody>
              <TableContainer
                columns={columns}
                data={data && data?.length > 0 ? data : []}
                isGlobalFilter={true}
                customPageSize={10}
                showFooter={true}
              // className="custom-header-css"
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PayrollLoanPreClose;
